function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg181Guam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.13,
    y: 11.13,
    style: {
      fill: "#0052B4"
    },
    width: 489.739,
    height: 489.739
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M245.344,374.865c-2.573-2.206-63.028-54.762-63.028-118.865s60.455-116.659,63.028-118.865L256,128  l10.656,9.134c2.573,2.206,63.028,54.762,63.028,118.866s-60.455,116.66-63.028,118.866L256,384L245.344,374.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M313.311,256c0-57.311-57.311-106.434-57.311-106.434S198.689,198.692,198.689,256  c0,17.532,5.367,34.295,12.813,49.123h88.994C307.942,290.295,313.311,273.532,313.311,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M313.311,256c0,17.532-5.368,34.295-12.813,49.123L256,313.311l-44.497-8.188  c-7.445-14.828-12.813-31.591-12.813-49.123H313.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,362.434c0,0,27.605-23.669,44.497-57.311h-88.994C228.395,338.765,256,362.434,256,362.434z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6DA544"
    },
    points: "219.157,223.251 292.842,223.251 256,260.094 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.723,
    y: 247.808,
    style: {
      fill: "#A2001D"
    },
    width: 24.565,
    height: 73.683
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg181Guam);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };